import { getApiRequest } from 'api';
import { AssignmentType } from 'types/assignment';

export const getAssignmentTypes = (): Promise<(AssignmentType & { weight: number })[]> => {
    return getApiRequest('/assignment/types/');
};
